import { useCallback, useEffect } from 'react';
import taskManagerApi from '@/features/shared/services/taskManagerApi';
import { setMaintenanceMode } from './maintenanceManager';
const HEALTH_ENDPOINT = '/health';
export default function useBackendHealth(interval = 10000) {
    const check = useCallback(() => {
        return taskManagerApi.get(HEALTH_ENDPOINT)
            .then(() => setMaintenanceMode(false))
            .catch(() => setMaintenanceMode(true));
    }, []);
    useEffect(() => {
        check();
        const id = setInterval(check, interval);
        return () => clearInterval(id);
    }, [check, interval]);
    return { retry: check };
}
